import { cx } from "@suse-o11y/class-variance";
import { toDate } from "@suse-o11y/date-time";
import type { Time } from "@suse-o11y/date-time/time";
import React from "react";

import { Truncated } from "~/components/truncated";

import type { TimeRange } from "../../../app/state/view/timeline/TimeRange";
import { ComponentTooltip } from "../element-tooltip/ComponentTooltipBlock";

import { ComponentLink } from "./ComponentLink";

export interface ComponentLinkWithTypeProps {
	className?: string;
	name: string;
	identifier: string;
	type: string;
	timestamp: undefined | Time;
	timeRange: undefined | TimeRange;
	prefix?: React.ReactNode;
	onClick?: VoidFunction;
}

export const ComponentLinkWithType: React.FC<ComponentLinkWithTypeProps> = ({
	name,
	identifier,
	type,
	timestamp,
	timeRange,
	prefix,
	onClick,
	className,
	...props
}) => (
	<div {...props} className={cx("flex min-w-0 grow flex-row flex-nowrap gap-1", className)}>
		{prefix}
		<div className="min-w-0 max-w-3/4">
			<ComponentTooltip componentName={name} componentType={type}>
				<ComponentLink
					className="min-w-0"
					componentIdentifier={identifier}
					onClick={onClick}
					search={{
						timestamp: toDate(timestamp),
						timeRange,
					}}
					text={name}
					tooltip={false}
				/>
			</ComponentTooltip>
		</div>

		<Truncated className="flex-[1_1_0]" tooltip={type} truncate="middle">{`(${type})`}</Truncated>
	</div>
);
